import { Reducer } from "../../lib/redux";
import { ScheduleStatusActionTypes } from "./types";
import { ScheduleStatusActions } from "./actions";

export let defaultScheduleStatus: IIdDictionary<boolean> = {};

export let scheduleStatus: Reducer<IIdDictionary<boolean>, ScheduleStatusActions> = (state = defaultScheduleStatus, action) => {
    switch (action.type) {
        case ScheduleStatusActionTypes.SET_SCHEDULESTATUS: {
            const userId: string = action.payload.userId;
            if (userId) {
                return {
                    ...state,
                    [userId]: action.payload.isInitialized
                };
            }
            return state;
        }
        case ScheduleStatusActionTypes.CLEAR_SCHEDULESTATUS: {
            if (action.payload && action.payload.length > 0) {
                return Object.keys(state)
                    .filter(userId => action.payload.map(user => user.id).indexOf(userId) !== -1)
                    .reduce((curr, key) => ({
                        ...curr,
                        [key]: state[key]
                    }), {});
            }
            return {};
        }
        default:
            return state;
    }
};